import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import AdvancingProsperityHero from "./sections/AdvancingProsperityHero";
import CoreMissionVision from "./sections/CoreMissionVision";
import MetricsOfProgress from "./sections/MetricsOfProgress";
import StrategicPillars from "./sections/StrategicPillars";
import CommunityPartners from "./sections/CommunityPartners";
import StayConnected from "./sections/StayConnected";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <AdvancingProsperityHero />
      <CoreMissionVision />
      <MetricsOfProgress />
      <StrategicPillars />
      <CommunityPartners />
      <StayConnected />
      <Footer />
    </div>;
}